module.exports = __webpack_public_path__ + "static/img/ikonaScratchStart-OFF.a3909814.png";